<template>
  <div id="instances-list" class="instances-list-container">
    <generate-qr-code :isPopupActive="isPopupActive" :closeCallback="closeCallback"/>
    <chosen-instance-pop-up :is-active="isActiveChosen" @close="isActiveChosen = false"/>
    <connect-tokens-popup :isPopupActive="isOfficialPopupActive" :closeCallback="closeCallback"/>
    <finalize-batch-popup :isActive="isActiveFinalizeBatchModal" @isActiveFalse="isActiveFinalizeBatchModal = false"/>

    <vs-popup title="Insira o link gerado no PEC" :active.sync="isLgpdPopupActivate">
      <div class="w-full flex justify-center items-center pt-4 pb-4">
        <div class="w-6/12 flex justify-center items-center" style="flex-direction: column;">
          <vs-input class="w-full mt-4 mb-4" v-model="lgpdLink"/>

          <vs-button color="rgb(62, 201, 214)" type="filled" class="align-right" @click.prevent="sendLgpdLink()">
            <span>Enviar LGPD</span>
          </vs-button>
        </div>
      </div>
    </vs-popup>

    <vs-popup title="Conhecer o Módulo de Sms e Email" :active.sync="activePopupModule" @close="activePopupModule = false">
      <moduleSmsEmail @closeModuleSmsEmailFalse="closePopupHandler"></moduleSmsEmail>
    </vs-popup>

    <vs-popup title="Apelido" :active.sync="isNicknamePopupActivate">
      <div class="w-full flex justify-center items-center">
        <div class="w-9/12 flex justify-center items-center" style="flex-direction: column;">
          <div class="mb-4 w-full">
            <label class="vs-input--label">Apelido da Conexão</label>

            <vs-input
              type="text"
              key="nickname"
              name="nickname"
              :maxlength="20"
              v-validate="'required'"
              class="w-full mt-2"
              v-model="nickInstance.nickname"
            />

            <small class="text-small">
              Caracteres: {{ nickInstance.nickname.length }}/20
            </small>
          </div>

          <vx-input-group class="mb-5 w-full">
            <label class="vs-input--label">Selecione uma cor para a conexão</label>
            <div class="items-center">
              <div class="relative ml-3 flex">
                <vs-dropdown vs-trigger-click vs-custom-content>
                  <div class="flex items-center" >
                    <vs-icon icon="brightness_1" size="large" :color="nickInstance.color"></vs-icon>
                    <feather-icon size="large" icon="EditIcon" svgClasses="w-5 h-5 ml-3 hover:text-primary stroke-current"/>
                  </div>

                  <vs-dropdown-menu >
                    <div class="rounded-md bg-white shadow-xs px-4 py-3 ">
                      <div class="grid grid-cols-4 gap-4 gap-4">
                        <div v-for="(color, index) in colors" :key="index">
                          <template v-if="nickInstance.color === color">
                            <div
                              class="w-8 h-8 inline-block rounded-full cursor-pointer border-4 border-white"
                              :style="`background: ${color}; box-shadow: 0 0 0 2px rgba(0, 0, 0, 0.2);`"
                            />
                          </template>

                          <template v-if="nickInstance.color !== color">
                            <div
                              role="checkbox"
                              tabindex="0"
                              @click="nickInstance.color = color"
                              :aria-checked="nickInstance.color"
                              :style="`background: ${color};`"
                              class="w-8 h-8 inline-block rounded-full cursor-pointer border-4 border-white focus:outline-none focus:shadow-outline"
                            />
                          </template>
                        </div>
                      </div>
                    </div>
                  </vs-dropdown-menu>
                </vs-dropdown>

                <feather-icon
                  size="large"
                  icon="TrashIcon"
                  @click="nickInstance.color = ''"
                  svgClasses="w-5 h-5 ml-3 hover:text-danger stroke-current"
                />
              </div>
            </div>
          </vx-input-group>

          <vs-button class="align-right" @click.prevent="updateNickname()">
            Salvar
          </vs-button>
        </div>
      </div>
    </vs-popup>
    
    <div v-if="!offlinePlatform">
      <div class="mr-4" style="position: relative;" v-if="openImage && (dashBeta || typeConnection === 'tenancy.low-1')">
          <vs-row class="mb-2">
                <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="2">
                  </vs-col>
                    <vs-col vs-type="flex" vs-justify="center" vs-align="center">
                      <vx-card class="overflow-hidden">
                        <swiper class="swiper" :options="swiperOption">
                          <swiper-slide v-for="(image, index) in images" :key="index">
                            <div style="cursor: pointer;" class="absolute top-0 right-0 p-2" @click.prevent="ActiveImage">
                              <feather-icon :icon="openImage ? 'XIcon' : ''" svgClasses="h-6 w-6" />
                            </div>
                            <img class="full-width-image"
                                :src="require(`@/assets/images/brands/${image}`)"
                                style="cursor: pointer; margin-top: 5px; border-radius: 5px;"
                                width="100%"
                                @click="openActivePopupModule(image, index)"
                            />
                          </swiper-slide>
                        </swiper>
                        </vx-card>
                    </vs-col>
                    <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="2">
                </vs-col>
          </vs-row>
          <vs-row v-if="images && images.length > 1">
            <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="12" class="mt-8">
              <div class="swiper-pagination" ></div>
            </vs-col>
          </vs-row>
        </div>

      <vs-table
        search
        pagination
        ref="table"
        :data="instances"
        v-model="selected"
        :max-items="itemsPerPage"
        noDataText="Sem dados disponíveis"
      >
        <div slot="header" class="flex-grow flex flex-wrap-reverse items-center">
          <vs-dropdown vs-trigger-click class="cursor-pointer mr-4">
            <div class="
              p-4 mb-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg
              cursor-pointer flex items-center justify-between font-medium
            ">
              <span class="mr-2">
                {{ currentPage * itemsPerPage - (itemsPerPage - 1) }} -
                {{
                  instances.length - currentPage * itemsPerPage > 0
                  ? currentPage * itemsPerPage
                  : instances.length
                }} de {{ queriedItems }}
              </span>
              <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
            </div>
            <vs-dropdown-menu>
              <vs-dropdown-item @click="itemsPerPage=4" @touchstart.prevent="itemsPerPage=4">
                <span>4</span>
              </vs-dropdown-item>
              <vs-dropdown-item @click="itemsPerPage=10" @touchstart.prevent="itemsPerPage=10">
                <span>10</span>
              </vs-dropdown-item>
              <vs-dropdown-item @click="itemsPerPage=15" @touchstart.prevent="itemsPerPage=15">
                <span>15</span>
              </vs-dropdown-item>
              <vs-dropdown-item @click="itemsPerPage=20" @touchstart.prevent="itemsPerPage=20">
                <span>20</span>
              </vs-dropdown-item>
            </vs-dropdown-menu>
          </vs-dropdown>
          <vs-button
            icon-pack="feather"
            icon="icon-hard-drive"
            class="vs-button-primary mb-4 select-none"
            v-if="canSee('chat-batch-finalize')"
            @click.prevent="isActiveFinalizeBatchModal = true"
          >
            Encerrar Atendimentos
          </vs-button>
          <div class="flex flex-wrap" v-if="unifyConnections">
            <vs-button
              icon-pack="feather"
              icon="icon-settings"
              class="vs-button-primary mb-4 ml-3 select-none"
              @click.prevent="isActiveChosen = true"
            >
              Filtrar Conexões
            </vs-button>

            <vx-tooltip
              position="bottom"
              class="mt-2"
              text="Utilizando a funcionalidade de 'Unificar Conexões', você terá a capacidade de gerenciar diversas conexões de forma simultânea. Neste filtro, é possível selecionar quais conexões deseja utilizar, proporcionando maior flexibilidade e eficiência no atendimento."
            >
              <feather-icon icon="HelpCircleIcon" class="ml-2"/>
            </vx-tooltip>
          </div>
          <div class="flex flex-wrap items-center ml-5" @click="ActiveImage" v-if="dashBeta || typeConnection === 'tenancy.low-1'">
            <vs-button v-if="!openImage" icon-pack="feather" icon="icon-propaganda" class="vs-button-primary mb-4 select-none">
              Ver Anúncio
            </vs-button>
          </div>
        </div>

        <template slot-scope="{data}">
          <div class="p-5 mb-5 flex select-none justify-content-center button-unification" v-if="unifyConnections">
            <vs-button
              type="border"
              class="vs-button-primary"
              :disabled="!hasInstanceToUnify || lockButtons"
              @click.prevent="chooseThisInstance()"
            >
              Entrar em conexões unificadas
            </vs-button>

            <vx-tooltip
              class="mt-2"
              color="warning"
              position="bottom"
              v-if="!hasInstanceToUnify"
              text="Configure no botão 'Filtrar Conexões' quais conexões deseja utilizar."
            >
              <feather-icon icon="AlertTriangleIcon" svgClasses="ml-3 pt-1 w-7 h-7 text-warning"/>
            </vx-tooltip>
          </div>

          <vs-alert v-if="incidentStatus !== 'UP'" title="AVISO! 🚨" color="rgb(231, 154, 23)" active="true">
            Estamos enfrentando algumas instabilidades em nossa plataforma no momento. 
            Nossa equipe já está trabalhando para resolver o problema o mais rápido possível. 
            Para acompanhar as atualizações sobre a situação, acesse: <a href="http://pedbot.instatus.com">pedbot.instatus.com</a> Se precisar de suporte, 
            entre em contato conosco, e faremos o possível para ajudá-lo.
          </vs-alert>

          <div class="select-none flex flex-wrap pt-4">
            <p class="text-3xl text-gray-500 px-2 relative overflow-hidden"> Conexões Ativas/Conexão Única </p>
            <vx-tooltip
              v-if="!isSmallScreen"
              position="bottom"
              class="align-self-center"
              text="Cada conexão representa um número de atendimento específico; escolha a que deseja utilizar para conversar exclusivamente por meio dela."
            >
              <feather-icon icon="HelpCircleIcon"/>
            </vx-tooltip>
          </div>

          <tbody class="flex flex-wrap" v-if="!twoFactorActivated">
            <div :key="index" v-for="(tr, index) in data">
              <card-instance
                class="m-3"
                :instance="tr"
                :lockButtons="lockButtons"
                @redirect="redirectTo"
                @connect="activatePopUp"
                @send-term="openLgpdPopUp"
                @selected="chooseThisInstance"
                @close-tickets="activateFinalize"
                @edit-nickname="openNicknamePopUp"
              />
            </div>
          </tbody>
        </template>
      </vs-table>
    </div>
    <div v-else>
      <offline></offline>
    </div>
  </div>
</template>

<script>

  import moduleSmsEmail from "@/views/module-sms-email/infos/index.vue"
  import GenerateQrCode from './GenerateQrCode.vue'
  import ConnectTokensPopup from './ConnectTokensPopup.vue'

  import moduleInstance from '@/store/instance/moduleInstance'
  import moduleSettings from '@/store/settings/moduleSettings'

  import { connect, disconnect } from "@/websockets/client.js"
  import {formatRouteTenantPath, hasPermission, maskLimitMessageTemplate, maskPhoneNumber, getCurrentTenant} from '@/utils'

  import whatsapp from '@/http/requests/whatsapp'
  import chatContact from "@/http/requests/chatContact"

  import Offline from "@/views/offline-platform/Offline.vue";
  import CardInstance from "@/views/instances/CardInstance.vue";
  import VsDropdown from "../../components/vs-dropdown/dropdown.vue";
  import FinalizeBatchPopup from '../chat-attendance/FinalizeBatchPopup'
  import ChosenInstancePopUp from "@/views/instances/ChosenInstancePopUp.vue";
  import VsDropdownMenu from "../../components/vs-dropdown/dropdown-menu.vue";
  import VsDropdownItem from "../../components/vs-dropdown/dropdown-item.vue";

  import { ChatTicketService } from "@/db/chatTicket_service";
  import { CustomerChatService } from "@/db/customerChat_service";
  import { CustomerService } from "@/db/customer_service";
  import { SettingsService } from "@/db/settings_service";
  import { dashBetas } from '@/supports/betaNotificationSupport'
  import 'swiper/swiper-bundle.css'
  import { swiper, swiperSlide } from 'vue-awesome-swiper'

  import user from '@/http/requests/user'

  export default {
    name: 'instances-list',
    data() {
      return {
        typeConnection: '',
        openImage: false,
        selected: [],
        chooseInstance: [],
        sidebarData: {},
        lgpdInstance: {},
        nickInstance: { nickname: '' },
        instance: { id: 0,  phone_number: '', activated: false },
        lgpdLink: '',
        itemsPerPage: 4,
        isMounted: false,
        lockButtons: false,
        isPopupActive: false,
        chooseInstance: false,
        isActiveChosen: false,
        addNewDataSidebar: false,
        isLgpdPopupActivate: false,
        isOfficialPopupActive: false,
        isNicknamePopupActivate: false,
        isActiveFinalizeBatchModal: false,
        activePopupModule: false,
        twoFactorActivated: false,
        dashBeta: false,
        colors: [
          '#ac610d','#ff5722','#b60ca0','#e50950',
          '#6c1a54','#04d9ff','#0235cc','#3f5fd0',
          '#423572','#08e0ae','#07a092','#1db954',
          '#0b6509','#6d7c21','#52391c','#757380'
        ],
        images: ['bannerCampaigns.png'],
        swiperOption: {
          pagination: {
            el: '.swiper-pagination',
            type: 'bullets',
            clickable: true
          },
          autoplay: {
            delay: 8000,
            disableOnInteraction: false
          },
        }
      }
    },
    computed: {
      currentPage() {
        return (this.isMounted && this.$refs.table) ? this.$refs.table.currentx : 0
      },
      isSmallScreen(){
        return window.innerWidth <= 400
      },
      queriedItems() {
        return this.$refs.table ? this.$refs.table.queriedResults.length : this.instances.length
      },
      offlinePlatform() {
        return this.$store.state.offlinePlatform;
      },
      unifyConnections() {
        return this.$store.state.settings.settings.unify_connections !== undefined && !!parseInt(this.$store.state.settings.settings.unify_connections);
      },
      hasInstanceToUnify() {
        return !!Number(this.$store.getters["instance/chosenInstanceIds"].length || 0)
      },
      instances() {
        if (!moduleInstance.isRegistered) {
          this.$store.registerModule('instance', moduleInstance)
          moduleInstance.isRegistered = true
        }
        return this.$store.state.instance.instances !== undefined ? this.$store.state.instance.instances : []
      },
      incidentStatus() {
        return this.$store.state.settings.incidentStatus
      }
    },
    watch: {
      '$store.state.AppActiveUser': {
        handler(newVal, oldVal) {
            if (newVal.twofactor_activity && !newVal.is_two_factor_validated) {
              this.twoFactorActivated = true;
            } else {
              this.twoFactorActivated = false;
            }
          },
          deep: true
        },
      'instances': {
        handler (instances) {
          if (this.instance.id !== null) {
            const instanceIndex = instances.findIndex((i) => i.id === this.instance.id)
            if (instances[instanceIndex] !== undefined) {
              this.wppQrCode = instances[instanceIndex].qr_code
              this.$vs.loading.close('#div-with-loading > .con-vs-loading')
              if (instances[instanceIndex].activated && instances[instanceIndex].activated !== this.instance.activated) {
                this.isPopupActive = false
                return this.$vs.notify({
                  color: 'success',
                  title: 'Conexão ativa!',
                  text: 'A conexão do whatsapp foi realizada com sucesso!'
                })
              }
            }
          }
        },
        deep: true
      },
      '$route.params.chooseInstance': {
        handler (chooseInstance) {
          let searchParams = {}

          if (chooseInstance === 'choose-instance') {
            searchParams = { orderBy: 'activated' }
            this.chooseInstance = true
          } else {
            this.chooseInstance = false
          }

          searchParams.user_id = this.$store.state.AppActiveUser.id
            this.$store.dispatch("instance/fetch", searchParams)

          if ( this.$route.query.refresh && this.$store.state.instance.refreshInstancesObject && this.$store.state.instance.refreshInstancesObject.length > 0) {
            return this.chooseThisInstance(JSON.parse(JSON.stringify(this.$store.state.instance.refreshInstancesObject)), true);
          }

          if (this.unifyConnections){
            this.fetchInstancesUnion()
          }
        },
        immediate: true
      },
      itemsPerPage(){
        if (this.isMounted && this.$refs.table){
          this.$refs.table.currentx = 1
        }
      }
    },
    methods: {
      closePopupHandler() {
        this.activePopupModule = false;
      },
      openActivePopupModule(){
        this.activePopupModule = true
      },
      ActiveImage() {
        this.openImage = !this.openImage;
        if(this.openImage){
          localStorage.setItem('imageState', true)
        }else{
          user.updateViewBanner(false).then((response) => {
            localStorage.setItem('imageState', false)
          })
        }
      },
      maskLimitMessageTemplate,
      maskPhoneNumber,
      closeCallback () {
       this.isPopupActive = false
       this.isOfficialPopupActive = false
      },
      sendLgpdLink() {
        whatsapp.sendLgpdLink(this.lgpdLink, this.lgpdInstance.id).then(() => {
          this.isLgpdPopupActivate = false
          return this.$vs.notify({
            color: 'success',
            title: 'Mensagem Enviada!',
            text: 'A mensagem informada pelo link foi enviada para o cliente.'
          })
        }).catch(() => {
          return this.$vs.notify({
            color: 'warning',
            title: 'Mensagem Falhou!',
            text: 'Ocorreu um erro no disparo do link da lgpd.'
          })
        })
      },
      async updateNickname(){
        let instance = {
          id: this.nickInstance.id,
          color: this.nickInstance.color,
          nickname: this.nickInstance.nickname.trim()
        };

        await this.$store.dispatch("instance/update", instance).then(() => {
          this.isNicknamePopupActivate = false
          this.$vs.notify({
            time: 7000,
            color: 'success',
            title: 'Atualização efetuada.'
          });
        }).catch((error) => { console.error(error) })
      },
      openNicknamePopUp(instance){
        this.nickInstance = JSON.parse(JSON.stringify(instance))
        this.nickInstance.nickname = this.nickInstance.nickname || ''
        this.nickInstance.color = this.nickInstance.color || ''
        this.isNicknamePopupActivate = true
      },
      openLgpdPopUp(instance) {
        this.lgpdLink = ''
        this.lgpdInstance = JSON.parse(JSON.stringify(instance))
        this.isLgpdPopupActivate = true
      },
      activatePopUp(instance) {
        this.instance.id = instance.id
        this.instance.activated = instance.activated
        this.instance.phone_number = maskPhoneNumber(instance.phone_number)
        this.$store.dispatch("instance/chooseInstanceObject", instance)
        if (instance.is_official) {
          this.isOfficialPopupActive = true
          return
        }
        this.isPopupActive = true
      },
      activateFinalize(option = 'all', instanceIds = [], userIds = []){
        this.isActiveFinalizeBatchModal = true
        this.$emit("change-finalize-batch", {option, instanceIds, userIds});
      },
      redirectTo(page, id, open = false){
        const path = formatRouteTenantPath(`/instances/${page}/${id}`);
        if ( open ) return window.open(this.$router.resolve(path).href, '_blank');
        this.$router.push(path);
      },
      addNewData() {
        this.sidebarData = {}
        this.toggleDataSidebar(true)
      },
      deleteData(instanceId) {
        this.$store.dispatch("instance/delete", instanceId).catch(err => { console.error(err) })
      },
      editData(data) {
        // this.sidebarData = JSON.parse(JSON.stringify(this.blankData))
        this.sidebarData = this.$_.cloneDeep(data)
        this.toggleDataSidebar(true)
      },
      toggleDataSidebar(val=false) {
        this.addNewDataSidebar = val
      },
      getInStorageGroupsSelectedFilter(){
        this.$store.dispatch("chatContact/getInStorageGroupsSelectedFilter");
      },
      fetchInstancesUnion(){
        if ( !this.$route.query.refresh && this.$store.state.instance.refreshInstancesObject.length === 0){
          this.lockButtons = true
          this.$store.dispatch("instance/chosenInstancesUnion", this.$store.state.AppActiveUser.id)
            .then(() => { this.lockButtons = false })
            .catch((error) => {
              this.lockButtons = false;
              console.error(error);
            })
        }
      },
      async chooseThisInstance(instance = null, refresh = false) {
        await this.$store.dispatch("instance/chooseRefreshInstancesObject", [])
        disconnect();
        connect();

        let instanceIds  = null
        const ctService  = new ChatTicketService();
        const ccService  = new CustomerChatService()
        const cService   = new CustomerService();
        const setService = new SettingsService();

        if ( refresh ){
          await this.$store.dispatch("instance/chosenInstances", instance)
          instanceIds = this.$store.getters["instance/chosenInstanceIds"]
        }
        else if ( instance ){
          instanceIds = [instance.id]
          await this.$store.dispatch("instance/chosenInstances", [instance])
        }
        else if ( this.$store.getters["instance/chosenInstanceIds"].length > 0 ) {
          instanceIds = this.$store.getters["instance/chosenInstanceIds"]
        } else {
          return this.$vs.notify({
            time: 7000,
            color: 'danger',
            title: 'Não há conexões selecionadas!',
            text: "Selecione uma conexão no botão 'Filtro de Conexões'"
          })
        }

        if ( this.$store.getters["instance/chosenInstances"].length === 1 ){
          const instanceSelected = this.$store.getters["instance/chosenInstances"][0];
          await this.$store.dispatch('activeInstance', ( instanceSelected.nickname||instanceSelected.name ));
        }

        this.$vs.loading({
          type: 'radius',
          container: '#app',
          clickEffect: true,
          background: '#B3DEFF',
          text: 'Estamos carregando suas mensagens. O tempo pode variar de acordo com a quantidade de mensagens...'
        });

        await cService.clearTable(instanceIds)
        await ctService.clearTable(instanceIds);
        await ccService.clearTable(instanceIds);
        await setService.clearTable(instanceIds);

        console.log('cleared tables');

        await chatContact.firstLoad();
        await this.$router.push(formatRouteTenantPath('/chat/attendance'))
        
        this.$vs.loading.close('#app > .con-vs-loading')
      },
      canSee(action) {
        return hasPermission(action)
      },
    },
    components: {
      VsDropdown,
      VsDropdownItem,
      VsDropdownMenu,
      CardInstance,
      Offline,
      GenerateQrCode,
      ConnectTokensPopup,
      FinalizeBatchPopup,
      ChosenInstancePopUp,
      moduleSmsEmail,
      swiper,
      swiperSlide
    },
    created() {
      if (!moduleInstance.isRegistered) {
        this.$store.registerModule('instance', moduleInstance)
        moduleInstance.isRegistered = true
      }

      if (!moduleSettings.isRegistered) {
        this.$store.registerModule('settings', moduleSettings)
        moduleSettings.isRegistered = true
      }

      this.$store.dispatch("updateWhatsappStatus");
      this.$store.dispatch('activeInstance', null);
      this.$store.dispatch("updateMaintenanceStatus");
    },
    mounted() {
      const tenant = getCurrentTenant();
      this.dashBeta = dashBetas.includes(tenant);
      this.isMounted = true;
      this.fetchInstancesUnion();
      this.getInStorageGroupsSelectedFilter();
      this.$store.dispatch('user/infos');
      const viewBanner = this.$store.state.AppActiveUser.view_banner;
      this.openImage = JSON.parse(localStorage.getItem('imageState'))
      if(viewBanner){
        this.openImage = true
        localStorage.setItem('imageState', this.openImage)
      }
      this.typeConnection = localStorage.getItem('connectionDatabase');
    },
    beforeRouteLeave(to, from, next) {

      if (this.isPopupActive) {
        this.isPopupActive = false;
        setTimeout( ()=> { next(); }, 2);
      }
      else if (this.activePopupModule) {
        this.activePopupModule = false;
        setTimeout( ()=> { next(); }, 2);
      }
      else if (this.isLgpdPopupActivate) {
        this.isLgpdPopupActivate = false;
        setTimeout( ()=> { next(); }, 2);
      }
      else if (this.isOfficialPopupActive) {
        this.isOfficialPopupActive = false;
        setTimeout( ()=> { next(); }, 2);
      }
      else if (this.isActiveFinalizeBatchModal) {
        this.isActiveFinalizeBatchModal = false;
        setTimeout( ()=> { next(); }, 2);
      }
      else if (this.isActiveChosen) {
        this.isActiveChosen = false;
        setTimeout( ()=> { next(); }, 2);
      }
      else if (this.isNicknamePopupActivate) {
        this.isNicknamePopupActivate = false;
        setTimeout( ()=> { next(); }, 2);
      }
      else { next(); }
    },
  }
</script>

<style lang="scss">
  .con-vs-popup .vs-popup {
    width: 600px !important;
    height: auto !important;
  }

  .align-self-center{
    align-self: center;
  }

  .fit-content {
    width: max-content;
  }

  .justify-content-center {
    justify-content: center !important;

    @media screen and (max-width: 400px) {
      justify-content: inherit !important;
    }
  }

  #div-with-loading {
    width: 264px;
    height: 264px;
  }

  #instances-list {
    span.swiper-pagination-bullet {
      margin-left: 15px;
    }
  
    .button-unification {
      width: 100%;
      background: #fff;
      border-radius:10px;
      text-align:center;
      box-shadow: 0 4px 22px 0 rgba(0,0,0,.05);

      @media screen and (max-width: 400px) {
        width: calc(100% - 4.5rem);
      }
    }

    .qr-code {
      width: 50%;
    }

    .con-input-search {
      padding: 0;
    }

    .vs-con-table {
      .vs-table--header {
        display: flex;
        flex-wrap: wrap-reverse;
        margin-left: 1.5rem;
        margin-right: 1.5rem;
        > span {
          display: flex;
          flex-grow: 1;
        }

        .vs-table--search{
          padding-top: 0;

          .vs-table--search-input {
            padding: 0.9rem 2.5rem;
            font-size: 1rem;

            &+i {
              left: 1rem;
            }

            &:focus+i {
              left: 1rem;
            }
          }
        }
      }

      .vs-table {
        border-collapse: separate;
        border-spacing: 0 1.3rem;
        padding: 0 1rem;


        tr{
          box-shadow: 0 4px 20px 0 rgba(0,0,0,.05);
          td{
            padding: 10px;
            &:first-child{
              border-top-left-radius: .5rem;
              border-bottom-left-radius: .5rem;
            }
            &:last-child{
              border-top-right-radius: .5rem;
              border-bottom-right-radius: .5rem;
            }
            &.img-container {
              // width: 1rem;
              // background: #fff;

              span {
                display: flex;
                justify-content: flex-start;
              }

              .product-img {
                height: 110px;
              }
            }
          }
          td.td-check{
            padding: 20px !important;
          }
        }
      }

      .vs-table--thead{
        th {
          padding-top: 0;
          padding-bottom: 0;

          .vs-table-text{
            text-transform: uppercase;
            font-weight: 600;
          }
        }
        th.td-check{
          padding: 0 15px !important;
        }
        tr{
          background: none;
          box-shadow: none;
        }
      }

      .vs-table--pagination {
        justify-content: center;
      }
    }
  }

.full-width-image {
  width: 100%;
}

</style>
